import React from 'react';
import { publications } from '../data/mock';
import { Card, CardContent } from './ui/card';
import { BookOpen, FileText, BookMarked, FileCheck } from 'lucide-react';
import { Badge } from './ui/badge';

const Publications = () => {
  const getIcon = (type) => {
    switch (type) {
      case 'Book':
        return BookOpen;
      case 'Research':
        return FileText;
      case 'Review':
        return BookMarked;
      case 'Chapter':
        return FileCheck;
      default:
        return FileText;
    }
  };

  return (
    <section id="publications" className="py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Publications & Research
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Extensive contributions to medical literature and oncology education
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {publications.map((pub) => {
            const Icon = getIcon(pub.type);
            return (
              <Card key={pub.id} className="hover:shadow-lg transition-shadow duration-300">
                <CardContent className="pt-6">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center">
                      <Icon className="w-7 h-7 text-teal-700" />
                    </div>
                    <div className="flex-1">
                      <Badge variant="secondary" className="mb-2 bg-teal-100 text-teal-700">{pub.type}</Badge>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">{pub.title}</h3>
                      <p className="text-gray-600 leading-relaxed">{pub.description}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="bg-gradient-to-r from-teal-700 to-teal-600 rounded-2xl p-8 text-white text-center">
          <h3 className="text-3xl font-bold mb-4">Author & Editor</h3>
          <p className="text-lg mb-6 opacity-90">
            Editor and Author of "Clinical Oncology – VIVA VOCE, OSCES and ESMO Exam Compendium"
          </p>
          <p className="text-base opacity-80">
            A comprehensive resource for students preparing for oncology examinations and medical professionals
          </p>
        </div>
      </div>
    </section>
  );
};

export default Publications;